//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatInsufficientBlock } from './ReportMaterialsAutoDebit.js'

export default {
  name: 'ReportMaterialsAutoDebitDialog',
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  computed: {
    insufficientBlocks: function () {
      return (this.plan.insufficient || []).map(formatInsufficientBlock)
    }
  },
  methods: {
    onConfirm: function () {
      this.$emit('confirm')
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}
